import './literbokse-tracking.js';

/**
* Dtails+ Accept terms and conditions
*/

function fnDtailsCartTerms(event, action, status) {
  var cartTerms = event.closest('form').querySelector('dtails-cart-terms');
  if (cartTerms) {
    var cartTermsDrawer = cartTerms.querySelector('[data-dtails-cart-terms-drawer]'),
        orderRecap = document.querySelector('.cart-order__recap');
    if (action == 'open') {
      cartTermsDrawer.classList.add('dtails-cart-terms-drawer--opened');
      if (orderRecap) orderRecap.style.position = "relative";
    } else if (action == 'close') {
      cartTermsDrawer.classList.remove('dtails-cart-terms-drawer--opened');
      if (orderRecap) orderRecap.style.position = "sticky";
    }

    if (status == 'accept') {
      var cartTermsDrawerCheckbox = cartTerms.querySelector('[data-dtails-cart-terms-checkbox]');
      if (cartTermsDrawerCheckbox) cartTermsDrawerCheckbox.checked = true;
      localStorage.setItem('theme:cart-terms-accepted', 'true');
    }
  }
}

var DtailsCartTerms = class extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('submit', this._onSubmit);
    this.addEventListener("click", this._onClick);
    if (localStorage.getItem('theme:cart-terms-accepted') == 'true' ) {
      fnDtailsCartTerms(this, '', 'accept');
    }
  }

  _onClick(event) {
    if (event.target.closest('[data-dtails-cart-terms-drawer-link]')) {
      fnDtailsCartTerms(event.target, 'open');
      event.preventDefault();
    } else if (event.target.closest('[data-dtails-cart-terms-drawer-close]')) {
      fnDtailsCartTerms(event.target, 'close');
      event.preventDefault();
    } else if (event.target.closest('[data-dtails-cart-terms-accept-button]')) {
      fnDtailsCartTerms(event.target, 'close', 'accept');
      event.preventDefault();
    } else {
      return;
    }
  }

  _onSubmit(event) {
    const submit = event.target.querySelector('button');
    const termsCartTerms = submit.closest('form').querySelector('dtails-cart-terms');
    if (!termsCartTerms) return;

    const termsCheckbox = termsCartTerms.querySelector('[data-dtails-cart-terms-checkbox]');

    if (submit.getAttribute('name') === 'checkout' && termsCheckbox) {
      if (termsCheckbox.checked) {
        localStorage.setItem('theme:cart-terms-accepted', 'true');
      } else {
        fnDtailsCartTerms(event.target, 'open');
        submit.setAttribute("aria-busy", "false");
        event.preventDefault();
        return false;
      }
    }
  }

};
if (!window.customElements.get("dtails-cart-terms") && window.themeVariables.settings.dtailsCartTerms) {
  window.customElements.define("dtails-cart-terms", DtailsCartTerms);
}

export { DtailsCartTerms };

// Auto-apply collection location filter from cart attribute
document.addEventListener('DOMContentLoaded', function() {
  function applyAutoLocationFilter() {
    const marker = document.querySelector('[data-auto-location-filter]:not([data-applied])');
    if (!marker) return;
    marker.setAttribute('data-applied', '');
    const { paramName, value } = JSON.parse(marker.textContent);

    const form = document.querySelector('.collection__facets #facet-form');
    const input = form?.querySelector(`input[name="${paramName}"][value="${value}"]`);
    if (input) {
      form.querySelectorAll(`input[name="${paramName}"]`).forEach(el => el.checked = false);
      input.checked = true;
      form.dispatchEvent(new Event('change'));
    } else {
      const url = new URL(window.location);
      url.searchParams.delete(paramName);
      url.searchParams.append(paramName, value);
      window.location.replace(url);
    }
  }

  if (!document.querySelector('.collection__facets #facet-form')) return;
  applyAutoLocationFilter();
  new MutationObserver(applyAutoLocationFilter).observe(document.body, { childList: true, subtree: true });
});

// Location filter PLP
document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.collection-custom-locations-filter')) {
    document.addEventListener('click', function(event) {
      if (event.target.closest('.collection-custom-locations-filter .location-item')) {
        var locationItem = event.target.closest('.collection-custom-locations-filter .location-item');
        if (locationItem.classList.contains('active')) {
          locationItem.classList.remove('active');
        } else {
          // remove all other active classes
          document.querySelectorAll('.collection-custom-locations-filter .location-item').forEach(function(item) {
            item.classList.remove('active');
          });
          // add active class to clicked item
          locationItem.classList.add('active');
        }

        let filterParamName = locationItem.getAttribute('data-param-name');
        let filterValue = locationItem.getAttribute('data-value');
        if (document.querySelector(`.collection__facets #facet-form input[name="${filterParamName}"][value="${filterValue}"]`)) {
          // remove all other checked checkboxes with same name
          document.querySelectorAll(`.collection__facets input[name="${filterParamName}"]`).forEach(function(item) {
            item.checked = false;
          });
          if (locationItem.classList.contains('active')) {
            document.querySelector(`.collection__facets input[name="${filterParamName}"][value="${filterValue}"]`).checked = true;
          }
          // trigger submit form to apply filter
          document.querySelector('.collection__facets #facet-form').dispatchEvent(new Event('change'));
        }
      }
    });
  }
});

// bundle ATC now dispatches variant:add + cart:refresh natively

// toggle read more product card
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    if (e.target.matches('.toggle-read-more') && e.target.closest('.product-card')) {
      e.preventDefault();
      e.stopPropagation();
      e.target.closest('.product-card').classList.toggle('show-read-more');
    }
  });
});

// Literboks calculator
var LiterboksCalculator = class extends HTMLElement {
  constructor() {
    super();
    this.querySelector('#calculate').addEventListener('click', this.calculate.bind(this));
    this.querySelector('#btn_start_over').addEventListener('click', this.startOver.bind(this));
  }

  calculate() {
    const people = parseInt(this.querySelector('#number_of_persons').value) || 0;
    const scoops = parseInt(this.querySelector('#number_of_scoops').value) || 0;
    const totalScoops = scoops * people;

    const sizes = [0.75, 1, 1.5, 2];
    let best = null;

    // Try all combinations
    const maxCount = Math.ceil(totalScoops / (sizes[0] * 12));
    for (let size of sizes) {
      for (let count = 1; count <= maxCount; count++) {
        let totalLiters = size * count;
        let totalScoopsForCombo = totalLiters * 12;
        if (totalScoopsForCombo >= totalScoops) {
          let waste = totalScoopsForCombo - totalScoops;
          if (
            !best ||
            count < best.count ||
            (count === best.count && waste < best.waste)
          ) {
            best = {size, count, waste, totalLiters, totalScoopsForCombo};
          }
        }
      }
    }

    this.querySelector('.result-container').classList.remove('hidden');
    this.querySelector('.question-container').classList.add('hidden');
    if (this.querySelector(`.result-item[data-size="${best.size}"]`)) {
      this.querySelectorAll('.result-item').forEach(item => {
        item.classList.add('hidden');
      });
      this.querySelector(`.result-item[data-size="${best.size}"]`).classList.remove('hidden');
      let heading = this.querySelector(`.result-item[data-size="${best.size}"]`).querySelector('h2');
      if (heading) {
        heading.textContent = best.count + ' x ' + heading.textContent.replace(/^\d+ x /, '');
      }

      let largerSizeHeading = this.querySelector(`.result-item[data-size="${best.size}"]`).querySelector('h4');
      if (largerSizeHeading) {
        largerSizeHeading.textContent = best.count + ' x ' + largerSizeHeading.textContent.replace(/^\d+ x /, '');
      }
    } else {
      // fallback to first item
      this.querySelectorAll('.result-item').forEach(item => {
        item.classList.add('hidden');
      });
      this.querySelector('.result-item').classList.remove('hidden');
    }
  }

  startOver() {
    this.querySelector('.result-container').classList.add('hidden');
    this.querySelector('.question-container').classList.remove('hidden');
  }
};
if (!window.customElements.get("listerboks-calculator")) {
  window.customElements.define("listerboks-calculator", LiterboksCalculator);
}

export { LiterboksCalculator };